import { render, staticRenderFns } from "./InspectForm.vue?vue&type=template&id=1bdf5a43&scoped=true&"
import script from "./InspectForm.vue?vue&type=script&lang=js&"
export * from "./InspectForm.vue?vue&type=script&lang=js&"
import style0 from "./InspectForm.vue?vue&type=style&index=0&id=1bdf5a43&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf5a43",
  null
  
)

export default component.exports